// extracted by mini-css-extract-plugin
export default {"tabsBox":"ltJatzHQPyGqTdIayM4Q"};